import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie';

const initialState = {
  isLogged: false,
  name: 'Loading...',
  email: 'Loading...',
  phone_number: 'Loading...',
  nickname: 'Loading...',
  flags: {
    sound: true,
    view_expired_event: false,
    onboarding: true,
    has_demo: true,
    new_user: false,
    has_dashboard_demo: true,
    has_identity_crafting_demo: true,
    has_prediction_crafting_demo: true,
    has_buypacks_demo: true,
    has_marketplace_demo: true,
  },
  auth_id: '',
  balance: 0,
  user_wallet: null,
  token: null,
  notificationsList: [],
  errorText: null,
  isAuthLoading: false,
  isMobile: false,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logInAccount: (state, action) => {
      const {isLogged, name, email, phone_number, nickname, flags, auth_id, balance, user_wallet, token} = action.payload;
      state.isLogged = isLogged
      state.name = name;
      state.email = email;
      state.phone_number = phone_number;
      state.nickname = nickname;
      state.flags = flags
      state.auth_id = auth_id
      state.balance = balance;
      state.user_wallet = user_wallet
      state.token = token;
      state.isAuthLoading = false;
      Cookies.set('token', token);
    },
    logOutAccount: (state) => {
      Object.assign(state, initialState);
      sessionStorage.clear();
      const cookies = Cookies.get();
      for (let cookieName in cookies) {
        Cookies.remove(cookieName);
      }
    },
    setError: (state, action) => {state.errorText = action.payload},
    setIsAuthLoading: (state, action) => {state.isAuthLoading = action.payload},
    setNotifications: (state, action) => {state.notificationsList = action.payload},
    setIsMobile: (state, action) => {state.isMobile = action.payload},
    editUser: (state, action) => {
      const { field, value } = action.payload;
      if (field in state) {
        state[field] = value;
      }
    },
    editUsersFlag: (state, action) => {
      const { field, value } = action.payload;
      if (field in state.flags) {
        state.flags[field] = value;
      }
    }
  },
})

export const { logInAccount, logOutAccount, setError, setIsAuthLoading, setNotifications, setIsMobile, editUser, editUsersFlag } = userSlice.actions

export default userSlice.reducer;
